export const dataCollectionListGridSettingsKey = 'CDP_DATA_COLLECTION_LIST_GRID_SETTINGS';
export const entityBulkEditGridSettingsKey = 'CDP_ENTITY_BULK_EDIT_GRID_SETTINGS';
export const entityListGridSettingsKey = 'CDP_ENTITY_LIST_GRID_SETTINGS';
export const scheduleJobsGridSettingsKey = 'CDP_SCHEDULE_JOBS_GRID_SETTINGS';
export const scheduleListGridSettingsKey = 'CDP_SCHEDULE_LIST_GRID_SETTINGS';
export const appListGridSettingsKey = 'CDP_ADMIN_APPS_LIST_GRID_SETTINGS';
export const scheduleModalGridSettingsKey = 'CDP_SCHEDULE_MODAL_GRID_SETTINGS';
export const sourceListGridSettingsKey = 'CDP_SOURCE_LIST_GRID_SETTINGS';
export const tenantListGridSettingsKey = 'CDP_TENANT_LIST_GRID_SETTINGS';
export const scheduleJobsModalGridSettingsKey = 'CDP_SCHED_JOBS_MODAL_GRID_SETTINGS';
export const addJobsModalGridSettingsKey = 'CDP_ADD_JOBS_MODAL_GRID_SETTINGS';
export const queueJobsModalGridSettingsKey = 'CDP_QUEUE_JOBS_MODAL_GRID_SETTINGS';
export const jobStateModalGridSettingsKey = 'CDP_JOB_STATE_MODAL_GRID_SETTINGS';
export const pmGlobalJobRunGridSettingsKey = 'CDP_GLOBAL_JOB_RUN_GRID_SETTINGS';
export const tenantContentLayoutConfigListGridSettingsKey = 'CDP_TENANT_CONTENT_LAYOUT_CONFIG_LIST_GRID_SETTINGS';
export const tenantRoleGridSettingsKey = 'CDP_ACCESS_ROLE_GRID_SETTINGS';
export const usersListGridSettingsKey = 'CDP_USERS_LIST_GRID_SETTINGS';
export const userDetailGroupListGridSettingsKey = 'CDP_USER_DETAIL_GROUP_LIST_GRID_SETTINGS';
export const groupsListGridSettingsKey = 'CDP_GROUPS_LIST_GRID_SETTINGS';
export const groupDetailUserListGridSettingsKey = 'CDP_GROUP_DETAIL_USERS_LIST_GRID_SETTINGS';
export const releaseNotesListGridSettingsKey = 'CDP_RELEASE_NOTES_LIST_GRID_SETTINGS';
export const dmPromotionHistoryGridSettingsKey = 'CDP_DM_PROMOTION_HISTORY_GRID_SETTINGS';
